import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_kelly from "@amcharts/amcharts4/themes/kelly"
import { ApiCallService2 } from '@app/routes/dashboard/pages/Real-time-perfomance/api-call-service';
import { setTheme } from 'ngx-bootstrap/utils';
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment"
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
const timeZoneUS = environment.timeZone;



@Component({
  selector: 'app-popup1',
  templateUrl: './popup1.component.html',
  styleUrls: ['./popup1.component.css']
})
export class Popup1Component implements OnInit, OnDestroy {
  maxDate = new Date();
  TokenHandler: any;
  myDateValue: any;
  type: any;
  dateRangaPicker: any;
  private chart1: am4charts.XYChart;
  private chart2: am4charts.XYChart;
  record_time: string[] = [];
  finalAggtemp: number[] = [];
  finalAggmois: number[] = [];
  analysis: any;
  temp: any;
  time: any;
  production: any;
  isLoading: any;
  historyData: any;
  appliedDateFilters: any = {};
  KPI1: any;
  KPI2: any;
  startDate: any;
  endDate: any;
  StatusType: any;
  SelectedTemp: any;
  SelectedHumidity: any;
  previousType = "MH";
  selectedMixId: string = 'All';
  mixIdOptions: any[] = [];

  private previousDateValue: Date;
  imageData: any;
  imageSrc: string;
  image: SafeUrl;
  gas_data: any;
  fanPosition: any;
  plantData: any;
  energySavings: any;
  productionImprovement: any;
  constructor(
    public dialogRef1: MatDialogRef<Popup1Component>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiCallService: ApiCallService2,
    private router: Router,
    private sanitizer: DomSanitizer
  ) { }
  cosntructor() {
    setTheme('bs3');
  }
  ngOnInit() {
    this.isLoading = true;
    this.imageSrc = null;
    this.myDateValue = new Date();
    this.previousDateValue = this.myDateValue;
    this.SelectedHumidity = true;
    this.SelectedTemp = false;
    this.getUnifiedData();
  }

  ngOnDestroy() {
  }
  private datesAreEqual(date1: Date, date2: Date): boolean {
    return date1 && date2 && date1.getTime() === date2.getTime();
  }

  onDateChange(newValue: Date): void {
    if (!this.datesAreEqual(newValue, this.previousDateValue)) {
      this.isLoading = true;
      this.getUnifiedData();
      console.log('date', this.startDate);
      this.previousDateValue = newValue;
    }
  }
  onMixIdChange(num) {
    if(num == 1){
 this.getMoistureData();
    }
    else if (num ==2){
       this.getSavingsData(10)
    }
    else if(num ==3)
    {
       this.getSavingsData(11)
    }
    console.log('Mix ID changed to:', this.selectedMixId);
    // Make new API call with selected mix ID
  }
 
  logout() {
    localStorage.clear();
    this.router.navigate(["auth"]);
  }
  timeStampChange(plantData: any, epochAdd: any) {
    plantData.forEach(item => {
      item.record_time_epoch = ((item.record_time / 1000) - epochAdd) * 1000;
    });
  }
  getPlantData(num: number) {

    this.apiCallService.getLiveData().subscribe(
      (data) => {
        this.plantData = Math.floor(data.plant_data[0].burner_pos);
        this.fanPosition = Math.floor(data.plant_data[0].exhaust_fan_pos);
        this.isLoading = false;
        setTimeout(() => {
          this.gaugeGraph(num);
        });

      },
      (error) => {
        console.error('Error fetching plant data:', error);
        this.isLoading = false;
      }
    );
  }
  getUnifiedData() {
    if (this.data == 1) {
      console.log(this.data, "moisture")

      this.type = 'moisture'
      this.getMoistureData();

    }
    if (this.data == 2 || this.data == 12) {
      this.type = 'temp'
      this.getTempData(this.data);
    }
    if (this.data == 3) {
      this.type = 'prod'
      // this.getProdData();
    }
    if (this.data == 4) {
      this.type = 'gasflow'
      this.getGasflowData();
    }
    if (this.data == 6) {
      this.type = 'gas'
      this.getGasConsumtion();
    }
    if (this.data == 5) {
      this.getImageData();
    }
    if (this.data == 7) {
      console.log(this.data)
      this.getPlantData(7);
    }
    if (this.data == 8) {
      console.log(this.data)
      this.getPlantData(8);
    }
    if (this.data == 10) {
      console.log(this.data, "energy savings")
      this.getSavingsData(10)
    }
    if (this.data == 11) {
      console.log(this.data, "production improvement")
      this.getSavingsData(11)
    }

  }
  aggMixTempGraph() {
    console.log("called")
    am4core.useTheme(am4themes_animated);
    // Create chart instance
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('aggmixtempchart', am4charts.XYChart);
    console.log('fontSize', fontSize);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    chart.data = this.KPI1;
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    chart.legend = new am4charts.Legend();
    // chart.legend.labels.template.fontWeight = "bold";
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    // dateAxis.title.fontWeight = 'bold';
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";

    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    dateAxis.skipEmptyPeriods = false;
    dateAxis.dateFormats.setKey("hour", "hh:mm a");  // Format for hour interval
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a"); // Prevent displaying dates
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    if (chart.data && chart.data[0] && chart.data[0].moisture_per === null) {
      valueAxis.max = 100;
    }
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Mix Aggegrate Temperature (°F)';
    valueAxis.title.fill = am4core.color('#FF8714');
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;

    // Create series for Actual Mix Temperature
    var series = chart.series.push(new am4charts.LineSeries());
    series.yAxis = valueAxis;
    series.dataFields.valueY = 'mix_temp_out';
    console.log(this.KPI1[0].virgin_agg_temp)
    series.dataFields.dateX = 'record_ts';
    series.name = 'Actual Mix Temperature';
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');
    series.legendSettings.labelText = "{name}";
    series.tooltipText = '[font-size: 12px]{name}: {valueY} (°F)[/]';
    series.strokeWidth = 2;
    series.tensionX = 1;
    series.connect = true; // Ensures lines connect points

    // Create series for Predicted Mix Temperature
    var series1 = chart.series.push(new am4charts.LineSeries());
    series1.yAxis = valueAxis;
    series1.dataFields.valueY = 'pred_mix_temp';
    series1.dataFields.dateX = 'record_ts';
    series1.name = 'Predicted Mix Temperature';
    series1.stroke = am4core.color('#007bff'); // Blue for contrast
    series1.fill = am4core.color('#007bff');
    series1.legendSettings.labelText = "{name}";
    series1.tooltipText = '[font-size: 12px]{name}: {valueY} (°F)[/]';
    series1.strokeWidth = 2;
    series1.tensionX = 1;

    // Add visible bullets (dots) to the Actual Mix Temperature series

    chart.legend.position = 'bottom';
    var title = chart.titles.create();
    title.fill = am4core.color('#fff');
  }
  gaugeGraph(num) {
    am4core.useTheme(am4themes_animated);
    // Create chart instance with hardcoded ID
    let chart
    if (num == 7) {
      chart = am4core.create("chartguageHistory1", am4charts.GaugeChart);
    }
    if (num == 8) {
      chart = am4core.create("chartguageHistory2", am4charts.GaugeChart);
    }
    chart.innerRadius = -10;
    chart.logo.disabled = true;

    // Create axis
    const axis = chart.xAxes.push(new am4charts.ValueAxis() as any);
    axis.min = 0;
    axis.max = 100;
    axis.strictMinMax = true;
    axis.fontSize = 8;
    axis.renderer.labels.template.disabled = true;
    axis.renderer.labels.template.fill = am4core.color("#fff");

    // Create label
    const label = chart.radarContainer.createChild(am4core.Label);
    label.isMeasured = false;
    label.fontSize = 12;
    label.x = am4core.percent(50);
    label.y = am4core.percent(100);
    label.horizontalCenter = "middle";
    label.verticalCenter = "bottom";
    if (num == 7) {
      label.text = this.plantData + "%";
    }
    if (num == 8) {
      label.text = this.fanPosition + "%";
    }
    label.fill = am4core.color("yellow");

    // Define ranges
    const range0 = axis.axisRanges.create();
    range0.value = 0;
    range0.endValue = 25;
    range0.label.text = "0";
    range0.axisFill.fillOpacity = 1;
    range0.axisFill.fill = am4core.color("#FFF176"); // Bright Yellow

    const range1 = axis.axisRanges.create();
    range1.value = 25;
    range1.endValue = 50;
    range1.label.text = "25";
    range1.axisFill.fillOpacity = 1;
    range1.axisFill.fill = am4core.color("#FFEB3B"); // Vivid Yellow

    const range2 = axis.axisRanges.create();
    range2.value = 50;
    range2.endValue = 75;
    range2.label.text = "50";
    range2.axisFill.fillOpacity = 1;
    range2.axisFill.fill = am4core.color("#AED581"); // Light Yellow-Green

    const range3 = axis.axisRanges.create();
    range3.value = 75;
    range3.endValue = 100;
    range3.label.text = "75";
    range3.axisFill.fillOpacity = 1;
    range3.axisFill.fill = am4core.color("#66BB6A"); // Bright Green

    const range4 = axis.axisRanges.create();
    range4.value = 100;
    range4.label.text = "100";

    // Create hand
    const hand = chart.hands.push(new am4charts.ClockHand());
    hand.fill = am4core.color("#ffffff");
    hand.stroke = am4core.color("#ffffff");
    hand.innerRadius = am4core.percent(30);
    hand.pin.disabled = true;

    if (num == 7) {
      new am4core.Animation(
        hand,
        {
          property: "value",
          to: this.plantData,
        },
        1000,
        am4core.ease.cubicOut
      ).start();
    }
    // Set hand value with animation using hardcoded value 76
    if (num == 8) {
      new am4core.Animation(
        hand,
        {
          property: "value",
          to: this.fanPosition,
        },
        1000,
        am4core.ease.cubicOut
      ).start();
    }

  }
  getGasflowData() {
    console.log('myDateValue', this.myDateValue);
    const myDate = new Date(this.myDateValue)
    console.log('myDate', myDate);
    let startEpoch = this.myDateValue.setHours(0, 0, 0, 0);
    let endEpoch = this.myDateValue.setHours(23, 59, 59, 999);
    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360;
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;

    const epochAdd = offsetDiff * 1800;

    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000;
    this.startDate = startEpoch;
    this.endDate = endEpoch;
    console.log('startDate: ', this.startDate)
    this.apiCallService
      .historyPlantData(
        this.startDate,
        this.endDate,
        this.type
      )
      .subscribe(
        (res) => {
          this.historyData = res;
          this.KPI1 = this.historyData.KPI_1;
          setTimeout(() => {
            this.KPI1.forEach(obj => {
              obj.value = 1;
            });

            this.KPI1.forEach(item => {
              item.record_time_epoch = ((item.record_time_epoch / 1000) - epochAdd) * 1000;
              item.gas_flow_rate = (item.gas_flow_rate / 100).toFixed(2);
              item.gas_flow_rate_actual = (item.gas_flow_rate * (1 - (360 - item.drum_temp) / 100 * (1 - item.moisture_per / 100))).toFixed(2)
            });
            this.drawLineChart4();
          }, 1000);
          setTimeout(() => {
            this.isLoading = false;
          }, 900)
          // this.isLoading=false;

        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error.message;
          console.log(this.TokenHandler);
          if (this.TokenHandler == "Token is invalid") {
            this.logout();
          }
        }
      );
  }
  getTempData(num) {
    console.log('myDateValue', this.myDateValue);
    const myDate = new Date(this.myDateValue)
    console.log('myDate', myDate);
    let startEpoch = this.myDateValue.setHours(0, 0, 0, 0);
    let endEpoch = this.myDateValue.setHours(23, 59, 59, 999);
    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360;
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;

    const epochAdd = offsetDiff * 1800;

    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000;
    this.startDate = startEpoch;
    this.endDate = endEpoch;
    console.log('startDate: ', this.startDate)
    this.apiCallService
      .historyPlantData(
        this.startDate,
        this.endDate,
        this.type
      )
      .subscribe(
        (res) => {
          this.historyData = res;
          this.KPI1 = this.historyData.KPI_1;
          setTimeout(() => {

            this.KPI1.forEach(obj => {
              obj.value = 1;
            });

            this.KPI1.forEach(item => {
              item.record_time_epoch = ((item.record_time_epoch / 1000) - epochAdd) * 1000;
            });
            if (num === 2) {
              this.drawLineChart2();
            } else if (num === 12) {
              this.aggMixTempGraph();
            }

          }, 1000);
          setTimeout(() => {
            this.isLoading = false;
          }, 900)
          // this.isLoading=false;

        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error.message;
          console.log(this.TokenHandler);
          if (this.TokenHandler == "Token is invalid") {
            this.logout();
          }
        }
      );
  }
  getProdData() {
    console.log('myDateValue', this.myDateValue);
    const myDate = new Date(this.myDateValue)
    console.log('myDate', myDate);
    let startEpoch = this.myDateValue.setHours(0, 0, 0, 0);
    let endEpoch = this.myDateValue.setHours(23, 59, 59, 999);
    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360;
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;

    const epochAdd = offsetDiff * 1800;

    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000;
    this.startDate = startEpoch;
    this.endDate = endEpoch;
    console.log('startDate: ', this.startDate)
    this.apiCallService
      .historyPlantData(
        this.startDate,
        this.endDate,
        this.type
      )
      .subscribe(
        (res) => {
          this.historyData = res;
          this.KPI2 = this.historyData.KPI_1
          setTimeout(() => {
            this.KPI2.forEach(item => {
              item.record_time_epoch = ((item.record_time_epoch / 1000) - epochAdd) * 1000;
            });
            this.drawProductionChart();
          }, 1000);
          setTimeout(() => {
            this.isLoading = false;
          }, 900)
          // this.isLoading=false;

        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error.message;
          console.log(this.TokenHandler);
          if (this.TokenHandler == "Token is invalid") {
            this.logout();
          }
        }
      );
  }
  getSavingsData(num: number) {
    const mydate = new Date(this.myDateValue);
    let startEpoch = mydate.setHours(0, 0, 0, 0);
    let endEpoch = mydate.setHours(23, 59, 59, 999);
    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360; // March to October
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;
    const epochAdd = offsetDiff * 1800;
    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000
    const mixIdForApi = this.selectedMixId === 'All' ? 'All' : this.selectedMixId;

    this.apiCallService
      .getSavingsData(startEpoch, endEpoch,mixIdForApi).subscribe(
        (res) => {
          console.log('API Response Savings:', res);
          this.energySavings = res.data;
          if (res.mix_id && Array.isArray(res.mix_id) && res.mix_id.length > 0) {
            this.mixIdOptions = [...res.mix_id]; // Create new array
            console.log('Updated mixIdOptions:', this.mixIdOptions);
          }
          setTimeout(() => {
            this.savingsGraph(num);
          }, 100);

          this.savingsGraph(num);
          this.isLoading = false;
        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error.message;
          console.log(this.TokenHandler);
          if (this.TokenHandler == "Token is invalid") {
            this.logout();
          }
        }
      );
  }
  savingsGraph(num: number) {
    am4core.useTheme(am4themes_animated);
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    const chart = am4core.create(`chartSavings${num}`, am4charts.XYChart);
    chart.logo.disabled = true;
    chart.padding(10, 10, 10, 10);
    chart.height = chartHeight;
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    chart.legend = new am4charts.Legend();
    // chart.legend.labels.template.fontWeight = "bold";
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    chart.data = this.energySavings
    console.log('Savings Data:', chart.data);

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.renderer.labels.template.fontSize = 15;
    dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    dateAxis.skipEmptyPeriods = false;
    dateAxis.dateFormats.setKey("hour", "hh:mm a");
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a");

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = num === 10 ? "Energy Savings(%)" : "Production Improvement(%)";
    valueAxis.min = 0;
    valueAxis.title.fill = am4core.color('#FF8714');
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;

    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = num === 10 ? "energy_savings" : "prod_improvement";
    series.dataFields.dateX = "record_ts";
    series.name = num === 10 ? "Energy Savings" : "Production Improvement";
    series.tooltipText = num === 10
      ? "Energy Savings: [bold]{energy_savings}%[/]"
      : "Production Improvement: [bold]{prod_improvement}%[/]";
    series.strokeWidth = 2;
    series.tensionX = 0.8;
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');

    

    // ✅ Cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = series;

  }
  getMoistureData() {
    console.log('myDateValue', this.myDateValue);

    const myDate = new Date(this.myDateValue);
    console.log('myDate', myDate);

    let startEpoch = this.myDateValue.setHours(0, 0, 0, 0);
    let endEpoch = this.myDateValue.setHours(23, 59, 59, 999);

    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360; // March to October
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;
    const epochAdd = offsetDiff * 1800;

    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000;

    this.startDate = startEpoch;
    this.endDate = endEpoch;

    console.log('startDate:', this.startDate);
    console.log('endDate:', this.endDate);
    const mixIdForApi = this.selectedMixId === 'All' ? 'All' : this.selectedMixId;

    this.apiCallService
      .moistureTrendData(this.startDate, this.endDate, mixIdForApi)
      .subscribe(
        (res) => {
          console.log('API Response:', res);
          this.historyData = res;
          this.KPI1 = res.data; // Direct assignment from API response
          if (res.mixid_data && Array.isArray(res.mixid_data) && res.mixid_data.length > 0) {
            this.mixIdOptions = [...res.mixid_data]; // Create new array
            console.log('Updated mixIdOptions:', this.mixIdOptions);
          }
          setTimeout(() => {
            this.KPI1.forEach(item => {
              item.record_time_epoch = item.record_time;
            });

            this.drawLineChart1();
          }, 1000);

          setTimeout(() => {
            this.isLoading = false;
          }, 900);
        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error && err.error.message;
          console.log(this.TokenHandler);

          if (this.TokenHandler === "Token is invalid") {
            this.logout();
          }
        }
      );
  }



  getGasConsumtion() {
    console.log('myDateValue', this.myDateValue);
    const myDate = new Date(this.myDateValue)
    console.log('myDate', myDate);
    let startEpoch = this.myDateValue.setHours(0, 0, 0, 0);
    let endEpoch = this.myDateValue.setHours(23, 59, 59, 999);
    const offsetValue = new Date(startEpoch).getTimezoneOffset();
    const month = new Date(this.myDateValue).getMonth();
    const offsetValueToUse = (month >= 2 && month <= 9) ? 300 : 360;
    const offsetDiff = (offsetValueToUse - offsetValue) / 30;

    const epochAdd = offsetDiff * 1800;

    startEpoch = ((startEpoch / 1000) + epochAdd) * 1000;
    endEpoch = ((endEpoch / 1000) + epochAdd) * 1000;
    this.startDate = startEpoch;
    this.endDate = endEpoch;
    console.log('startDate: ', this.startDate)
    this.apiCallService
      .historyPlantData(
        this.startDate,
        this.endDate,
        this.type
      )
      .subscribe(
        (res) => {
          this.historyData = res;
          this.gas_data = this.historyData.KPI_1;
          setTimeout(() => {
            this.gas_data.forEach(item => {
              item.record_time = (item.record_time - epochAdd) * 1000;
            })
            this.drawLineChart5();
          }, 1000);
          setTimeout(() => {
            this.isLoading = false;
          }, 900)
          // this.isLoading=false;

        },
        (err) => {
          console.log(err);
          this.TokenHandler = err.error.message;
          console.log(this.TokenHandler);
          if (this.TokenHandler == "Token is invalid") {
            this.logout();
          }
        }
      );
  }

  // getImageData() {
  //   this.apiCallService
  //     .getImageData().subscribe(
  //       (res) => {
  //         this.imageData = res.Images[0];
  //         this.imageSrc = `data:image/jpeg;base64,${this.imageData}`
  //         this.isLoading = false;
  //       },
  //       (err) => {
  //         console.log(err);
  //         this.TokenHandler = err.error.message;
  //         console.log(this.TokenHandler);
  //         if (this.TokenHandler == "Token is invalid") {
  //           this.logout();
  //         }
  //       }
  //     );
  // }
  getImageData() {
    this.apiCallService.getImageData().subscribe(
      (res) => {
        this.imageData = res.Images && res.Images.length > 0 ? res.Images[0] : null;

        if (this.imageData) {
          // If image exists
          this.imageSrc = `data:image/jpeg;base64,${this.imageData}`;
        } else {
          // ✅ Fallback image from assets
          this.imageSrc = 'assets/img/no-image.png';
        }

        this.isLoading = false;
      },
      (err) => {
        console.log(err);

        // ✅ Also fallback on error
        this.imageSrc = 'assets/img/no-image.png';
        this.isLoading = false;

        this.TokenHandler = err.error.message;
        if (this.TokenHandler == "Token is invalid") {
          this.logout();
        }
      }
    );
  }

  drawLineChart1() {
    am4core.useTheme(am4themes_animated);
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('lineChart1', am4charts.XYChart);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    chart.data = this.KPI1;
    console.log('KPI1 moisture data:', this.KPI1);
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd\'T\'HH:mm:ss';
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.renderer.labels.template.fontSize = 15;
    dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    dateAxis.skipEmptyPeriods = false;
    dateAxis.dateFormats.setKey("hour", "hh:mm a");
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a");
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 10; // Set based on your data range
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Moisture (%)';
    valueAxis.title.fill = am4core.color('#FF8714');
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;

    var series = chart.series.push(new am4charts.LineSeries());
    series.yAxis = valueAxis;
    series.dataFields.valueY = 'moisture_per';
    series.dataFields.dateX = 'record_ts'; // Use record_ts directly
    series.name = 'Moisture';
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');
    series.legendSettings.labelText = "{name}";
    series.tooltipText = '[font-size: 12px]{name}: {valueY}(%)[/]';
    series.strokeWidth = 2;
    series.tensionX = 1;
    chart.legend.position = 'bottom';
    var title = chart.titles.create();
    title.fill = am4core.color('#fff');
  }

  drawLineChart2() {
    console.log("called")
    am4core.useTheme(am4themes_animated);
    // Create chart instance
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('lineChart2', am4charts.XYChart);
    console.log('fontSize', fontSize);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    chart.data = this.KPI1;
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    chart.legend = new am4charts.Legend();
    // chart.legend.labels.template.fontWeight = "bold";
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    // dateAxis.title.fontWeight = 'bold';
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";

    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    dateAxis.skipEmptyPeriods = false;
    dateAxis.dateFormats.setKey("hour", "hh:mm a");  // Format for hour interval
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a"); // Prevent displaying dates
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    if (chart.data && chart.data[0] && chart.data[0].moisture_per === null) {
      valueAxis.max = 100;
    }
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Virgin Aggegrate Temperature (°F)';
    valueAxis.title.fill = am4core.color('#FF8714');
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;

    // Create series for Actual Mix Temperature
    var series = chart.series.push(new am4charts.LineSeries());
    series.yAxis = valueAxis;
    series.dataFields.valueY = 'virgin_agg_temp';
    console.log(this.KPI1[0].virgin_agg_temp)
    series.dataFields.dateX = 'record_ts';
    series.name = 'Actual Temperature';
    series.stroke = am4core.color('#FF8714'); // Orange
    series.fill = am4core.color('#FF8714');
    series.legendSettings.labelText = "{name}";
    series.tooltipText = '[font-size: 12px]{name}: {valueY} (°F)[/]';
    series.strokeWidth = 2;
    series.tensionX = 1;
    series.connect = true; // Ensures lines connect points

    // Create series for Predicted Mix Temperature
    var series1 = chart.series.push(new am4charts.LineSeries());
    series1.yAxis = valueAxis;
    series1.dataFields.valueY = 'pred_agg_temp';
    series1.dataFields.dateX = 'record_ts';
    series1.name = 'Predicted Temperature';
    series1.stroke = am4core.color('#007bff'); // Blue for contrast
    series1.fill = am4core.color('#007bff');
    series1.legendSettings.labelText = "{name}";
    series1.tooltipText = '[font-size: 12px]{name}: {valueY} (°F)[/]';
    series1.strokeWidth = 2;
    series1.tensionX = 1;


    chart.legend.position = 'bottom';
    var title = chart.titles.create();
    title.fill = am4core.color('#fff');
  }

  drawLineChart4() {
    am4core.useTheme(am4themes_animated);
    // Create chart instance
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('lineChart4', am4charts.XYChart);
    console.log('fontSize', fontSize);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    chart.data = this.KPI1;
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    chart.legend = new am4charts.Legend();
    // chart.legend.labels.template.fontWeight = "bold";
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    // dateAxis.title.fontWeight = 'bold';
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";


    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    // dateAxis.renderer.minGridDistance = minGridDistance;
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    dateAxis.skipEmptyPeriods = false;
    dateAxis.dateFormats.setKey("hour", "hh:mm a");  // Format for hour interval
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a"); // Prevent displaying dates
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    if (chart.data && chart.data[0] && chart.data[0].moisture_per === null) {
      valueAxis.max = 100;
    }
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Gas Flow Rate (CCF)';
    valueAxis.title.fill = am4core.color('#FF8714');
    // valueAxis.title.fontWeight = 'bold';
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;


    // var valueAxis1 = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis1.min = 0;
    // valueAxis1.max = 100;
    // valueAxis1.renderer.inside = false;
    // valueAxis1.renderer.labels.template.disabled = false;
    // valueAxis1.title.text = 'Moisture (%)';
    // valueAxis1.title.fill = am4core.color('#4CAF50');
    // valueAxis1.title.fontWeight = 'bold';
    // valueAxis1.renderer.labels.template.fontSize = fontSize;
    // valueAxis1.renderer.minGridDistance = minGridDistance;
    // valueAxis1.renderer.labels.template.fill = am4core.color('#4CAF50');
    // valueAxis1.cursorTooltipEnabled = false;
    // valueAxis1.renderer.opposite =true;

    // Create series
    var series = chart.series.push(new am4charts.LineSeries());
    series.yAxis = valueAxis;
    series.dataFields.valueY = 'gas_flow_rate';

    series.dataFields.dateX = 'record_time_epoch';
    series.name = 'Actual Gas Flow Rate';
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');
    series.legendSettings.labelText = "{name}";
    series.tooltipText = '[font-size: 12px]{name}: {valueY} (CFM)[/]';
    series.strokeWidth = 2;
    series.tensionX = 1;

    var series1 = chart.series.push(new am4charts.LineSeries());
    series1.yAxis = valueAxis;
    series1.strokeDasharray = "5,5";
    series1.dataFields.valueY = 'gas_flow_rate_actual';
    series1.dataFields.dateX = 'record_time_epoch';
    series1.name = 'Recommended Gas Flow Rate';
    series1.stroke = am4core.color('#FF8714');
    series1.fill = am4core.color('#FF8714');
    series1.legendSettings.labelText = "{name}";
    series1.tooltipText = '[font-size: 12px]{name}: {valueY} (CFM)[/]';
    series1.strokeWidth = 2;
    series1.tensionX = 1;

    // var series2 = chart.series.push(new am4charts.LineSeries());
    // series2.yAxis = valueAxis1;
    // series2.dataFields.valueY = 'moisture_per';
    // series2.dataFields.dateX = 'record_time_epoch';
    // series2.name = 'Moisture';
    // series2.stroke = am4core.color('#4CAF50');
    // series2.fill = am4core.color('#4CAF50');
    // series2.legendSettings.labelText = "{name}";
    // series2.tooltipText = '[font-size: 12px]{name}: {valueY} (%)[/]';
    // series2.strokeWidth = 2;
    // series2.tensionX = 0.8;

    // Add bullets to the series
    let bullet = series.bullets.push(new am4charts.Bullet());
    bullet.fill = am4core.color('#FF8714');
    let circle = bullet.createChild(am4core.Circle);
    circle.radius = 0;
    circle.stroke = am4core.color('#FF8714');
    circle.strokeWidth = 2;

    let bullet1 = series1.bullets.push(new am4charts.Bullet());
    bullet1.fill = am4core.color('#FF8714');
    let circle1 = bullet1.createChild(am4core.Circle);
    circle1.radius = 0;
    circle1.stroke = am4core.color('#FF8714');
    circle1.strokeWidth = 2;

    // let bullet2 = series2.bullets.push(new am4charts.Bullet());
    // bullet2.fill = am4core.color('#FF8714');
    // let circle2 = bullet2.createChild(am4core.Circle);
    // circle2.radius = 0;
    // circle2.stroke = am4core.color('#FF8714');
    // circle2.strokeWidth = 2;

    chart.legend.position = 'bottom';
    var title = chart.titles.create();
    title.fill = am4core.color('#fff');

  }

  drawLineChart5() {
    am4core.useTheme(am4themes_animated);
    // Create chart instance
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('lineChart5', am4charts.XYChart);
    console.log('fontSize', fontSize);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    chart.data = this.gas_data;
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    chart.legend = new am4charts.Legend();
    // chart.legend.labels.template.fontWeight = "bold";
    chart.legend.labels.template.fill = am4core.color("#FFFFFF");

    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;

    dateAxis.title.fill = am4core.color('#fff');
    // dateAxis.title.fontWeight = 'bold';
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');
    dateAxis.title.text = "Time";


    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    // dateAxis.renderer.minGridDistance = minGridDistance;
    dateAxis.renderer.labels.template.fontSize = fontSize;
    // dateAxis.baseInterval = { timeUnit: 'minute', count: 10 };
    // dateAxis.skipEmptyPeriods = false;
    // dateAxis.dateFormats.setKey("hour", "hh:mm a");  // Format for hour interval
    // dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a"); // Prevent displaying dates
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.min =1000000;
    //  valueAxis.max =1150000
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Gas Consumption (CCF)';
    valueAxis.title.fill = am4core.color('#FF8714');
    // valueAxis.title.fontWeight = 'bold';
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.renderer.labels.template.fill = am4core.color('#FF8714');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.cursorTooltipEnabled = false;

    // Create series
    var series = chart.series.push(new am4charts.LineSeries());
    series.yAxis = valueAxis;
    series.dataFields.valueY = 'gas_reading_correction';

    series.dataFields.dateX = 'record_time';
    series.name = 'Gas Consumption';
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');
    series.legendSettings.labelText = "{name}";
    series.tooltipText = '[font-size: 12px]{name}: {valueY} (CCF)[/]';
    series.strokeWidth = 2;
    series.tensionX = 1;

    let bullet = series.bullets.push(new am4charts.Bullet());
    bullet.fill = am4core.color('#FF8714');
    let circle = bullet.createChild(am4core.Circle);
    circle.radius = 0;
    circle.stroke = am4core.color('#FF8714');
    circle.strokeWidth = 2;

    chart.legend.position = 'bottom';
    var title = chart.titles.create();
    title.fill = am4core.color('#fff');

  }

  closed() {
    this.dialogRef1.close();
  }

  drawProductionChart() {

    am4core.useTheme(am4themes_animated);
    // Create chart instance
    const fontSize = this.getResponsiveFontSize();
    const minGridDistance = this.getResponsiveminGridDistance();
    const chartHeight = this.getResponsiveminChartHeight();
    var chart = am4core.create('chartProduction', am4charts.XYChart);
    console.log('fontSize', fontSize);
    chart.logo.disabled = true;
    chart.responsive.enabled = true;
    chart.paddingRight = 15;
    chart.marginRight = 15;
    chart.paddingLeft = 10;
    chart.marginLeft = 10;
    var chartData = this.KPI2;
    chart.data = chartData;
    chart.height = chartHeight;
    chart.width = am4core.percent(98);
    // Set input format for the dates
    chart.dateFormatter.inputDateFormat = 'yyyy-MM-dd H-mm';
    // Create axes
    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());

    let date = new Date();
    const myDateValue = new Date(this.myDateValue);
    const normalizedMyDateValue = new Date(myDateValue.setHours(0, 0, 0, 0));
    const normalizedCurrentDate = new Date(date.setHours(0, 0, 0, 0));

    if (normalizedMyDateValue.getTime() === normalizedCurrentDate.getTime()) {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
    } else {
      dateAxis.min = new Date(this.myDateValue).setHours(0, 0, 0, 0);
      dateAxis.max = new Date(this.myDateValue).setHours(23, 59, 59, 999);
    }
    dateAxis.renderer.grid.template.location = 0;
    //   dateAxis.renderer.minGridDistance = 20;
    // dateAxis.renderer.grid.template.stroke = am4core.color('#000');
    dateAxis.renderer.grid.template.stroke = am4core.color('#fff');

    // dateAxis.title.fill = '#fff';
    dateAxis.title.fill = am4core.color('#fff');
    // dateAxis.title.fontWeight = 'bold';
    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.renderer.labels.template.fontSize = fontSize;
    // dateAxis.renderer.labels.template.fill = am4core.color('#000');
    dateAxis.renderer.labels.template.fill = am4core.color('#fff');
    dateAxis.title.text = 'Time';
    dateAxis.renderer.labels.template.fontSize = fontSize;
    dateAxis.baseInterval = {
      timeUnit: 'hour',
      count: 1,
    };
    dateAxis.skipEmptyPeriods = false;
    // dateAxis.tooltipDateFormat = 'yyyy-MM-dd HH-mm';
    dateAxis.dateFormats.setKey("hour", "hh:mm a");  // Format for hour interval
    dateAxis.periodChangeDateFormats.setKey("hour", "hh:mm a"); // Prevent displaying dates
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.lineY.disabled = true;
    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    if (chart.data && chart.data[0] && chart.data[0].mix_tons_run === null) {
      valueAxis.max = 100;
    }
    valueAxis.renderer.inside = false;
    valueAxis.renderer.labels.template.disabled = false;
    valueAxis.title.text = 'Production (Tons)';
    // valueAxis.title.fill = am4core.color('#333');
    valueAxis.title.fill = am4core.color('#fff');
    // valueAxis.title.fontWeight = 'bold';
    valueAxis.renderer.labels.template.fontSize = fontSize;
    valueAxis.renderer.minGridDistance = minGridDistance;
    // valueAxis.renderer.labels.template.fill = am4core.color('#333');
    valueAxis.renderer.labels.template.fill = am4core.color('#fff');
    valueAxis.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis.renderer.minGridDistance = minGridDistance;
    valueAxis.cursorTooltipEnabled = false;
    var valueAxis1 = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis1.min = 0;
    valueAxis1.renderer.inside = false;
    valueAxis1.renderer.labels.template.disabled = true;
    //   valueAxis1.title.text = 'actual';
    // valueAxis1.title.fill = am4core.color('#333');
    valueAxis1.title.fill = am4core.color('#fff');
    // valueAxis1.title.fontWeight = 'bold';
    valueAxis1.renderer.labels.template.fontSize = fontSize;
    valueAxis1.renderer.minGridDistance = minGridDistance;
    // valueAxis1.renderer.labels.template.fill = am4core.color('#333');
    valueAxis1.renderer.labels.template.fill = am4core.color('#fff');
    valueAxis1.renderer.grid.template.stroke = am4core.color('#fff');
    valueAxis1.renderer.minGridDistance = minGridDistance;
    valueAxis1.cursorTooltipEnabled = false;
    valueAxis1.syncWithAxis = valueAxis;
    valueAxis1.renderer.opposite = false;
    valueAxis1.max = valueAxis.max;
    // Determine which emission type is selected and create series accordingly
    var series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'mix_tons_run';
    series.dataFields.dateX = 'record_time_epoch';
    series.name = 'Actual';
    // series.columns.template.width = am4core.percent(30);
    // series.columns.template.propertyFields.url = "url";
    series.strokeWidth = 3;
    series.stroke = am4core.color('#FF8714');
    series.fill = am4core.color('#FF8714');
    // series.legendSettings.labelText =  ' [ font-size:15px ]{name}[/]'
    series.tooltipText = '[font-size: 12px]{name}: {valueY}[/]';
    var series1 = chart.series.push(new am4charts.ColumnSeries());
    series1.dataFields.valueY = 'optimized_mix_tons_run';
    series1.yAxis = valueAxis;
    series1.dataFields.dateX = 'record_time_epoch';
    series1.name = 'Estimated Production';
    // series1.columns.template.width = am4core.percent(30);
    // series1.columns.template.propertyFields.url = "url";
    series1.strokeWidth = 3;
    series1.stroke = am4core.color('#00b050');
    series1.fill = am4core.color('#00b050');
    // series1.legendSettings.labelText =  ' [ font-size:12px ]{name}[/]'
    series1.tooltipText = '[font-size: 12px]{name}: {valueY}[/]';
    let bullet = series.bullets.push(new am4charts.Bullet());
    bullet.fill = am4core.color('#FF8714'); // tooltips grab fill from parent by default
    let circle = bullet.createChild(am4core.Circle);
    // circle.radius = 2;
    // circle.strokeWidth = 2;
    let bullet1 = series1.bullets.push(new am4charts.Bullet());
    bullet1.fill = am4core.color('#00b050'); // tooltips grab fill from parent by default
    let circle1 = bullet1.createChild(am4core.Circle);
    // circle1.radius = 2;
    // circle1.strokeWidth = 2;
    chart.legend = new am4charts.Legend();
    chart.legend.position = 'bottom';
    chart.legend.labels.template.fill = am4core.color('#fff');
    var title = chart.titles.create();
    title.fill = am4core.color('#333');
  }

  getResponsiveFontSize() {
    const screenWidth = window.innerWidth;

    // Set different font sizes based on screen width
    if (screenWidth > 1200) {
      return 15; // Large screens
    } else if (screenWidth > 768) {
      return 12; // Medium screens
    } else {
      return 10; // Small screens
    }
  }
  getResponsiveminGridDistance() {
    const screenWidth = window.innerWidth;

    // Set different font sizes based on screen width
    if (screenWidth > 1200) {
      return 40; // Large screens
    } else if (screenWidth > 768) {
      return 30; // Medium screens
    } else {
      return 20; // Small screens
    }
  }
  getResponsiveminChartHeight() {
    const screenWidth = window.innerWidth;

    // Set different font sizes based on screen width
    if (screenWidth > 1200) {
      return 400; // Large screens
    } else if (screenWidth > 768) {
      return 350; // Medium screens
    } else {
      return 300; // Small screens
    }
  }
}
